export default "__VITE_ASSET__B2Lc1tmm__"